module.exports = __webpack_public_path__ + "56d82239def716ceb197f27770b57b75.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-11.png
// module id = 2214
// module chunks = 0